import ChooseAccommodationContainer from './containers/ChooseAccommodationContainer';

export default ChooseAccommodationContainer;
